import { Component, OnDestroy, OnInit, Renderer2 } from '@angular/core';
import { GoalInfo, GoalService } from '@EYN/components/goals';
import { Observable } from 'rxjs';

@Component({
	selector: 'eyn-goal-overview',
	templateUrl: './goal-overview.component.html',
	styleUrls: ['./goal-overview.component.less']
})
export class GoalOverviewComponent implements OnInit, OnDestroy {

	goal$: Observable<GoalInfo>;

	constructor(private renderer: Renderer2, private goalService: GoalService) {
		this.goal$ = this.goalService.getGoalInfo();
	}

	ngOnInit() {
		this.renderer.addClass(document.body, 'ey-hide-breadcrumb');
	}

	ngOnDestroy() {
		this.renderer.removeClass(document.body, 'ey-hide-breadcrumb');
	}

}
